export default __webpack_public_path__ + "static/media/quanto.c5011fea.svg";